export default __webpack_public_path__ + "static/personal-loan-5e13f485c279cbdc6234def1eb972fa6.webp";